import { render } from "./Bell.vue?vue&type=template&id=7cafe046"
import script from "./Bell.vue?vue&type=script&lang=js"
export * from "./Bell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__